import Accordion from "./ui/Accordion";

const Services = () => {
    const list = [
        {
            title: 'Создание сайта', 
            body: <div>
                <p>Лендинг: 5 экрана (блока) - от 5 тыс. рублей
                + экран 500 рублей</p>
                <p>Многостраничный 
                информационный сайт: от 7 тыс. рублей </p>
            </div>
        },
        {
            title: 'Тех.поддержка сайта', 
            body: <div>
                <p>От 1 тыс. рублей</p>
                <p>Цена зависит от объема работ и CMS сайта</p>
            </div>
        },
        {
            title: 'SEO оптимизация сайта', 
            body: <div>
                <p>Минимальный аудит + исправление ошибок: от 5 тыс. рублей</p>
                <p>Полный аудит + исправление ошибок: от 10 тыс. рублей</p>                
                <p>Настройка микроразметки: от 1 тыс. рублей</p>                
                <p>Подключение вебмастеров и счетчиков: 500 рублей</p>
                <p>Поднятие скорости загрузки сайта: от 1 тыс. рублей</p>
            </div>
        }
      ];

    return (
        <div id="services" className="module">
            <h2>УСЛУГИ</h2>
            <Accordion tabList={list} />
        </div>
    );
  };
  
export default Services;